// extracted by mini-css-extract-plugin
export default {"form":"DistribuidorClientes_form__XOTRL","trBody":"DistribuidorClientes_trBody__n8uMs","areaBtn":"DistribuidorClientes_areaBtn__wRVBS","btn":"DistribuidorClientes_btn__jB74m"};